<template>
  <v-row
    class="
      justify-center
      d-flex
      mx-0
      mt-n16
      bg-white
      position-relative
      border-radius-xl
      shadow
    "
    :class="$vuetify.breakpoint.xs ? 'px-2' : 'px-4'"
  >
    <v-col cols="12" style="max-width: 1400px; margin: 0 auto;">
      <v-container fluid :class="$vuetify.breakpoint.xs ? 'py-3' : 'py-6'">
        <v-row :class="$vuetify.breakpoint.xs ? 'mt-4' : 'mt-10'" v-if="userInformations">
          <v-col cols="auto">
            <v-avatar
              style="cursor: pointer"
              width="74"
              height="74"
              class="shadow border-radius-lg"
              color="bg-gradient-warning"
              @click="$router.push('/profile')"
            >
              <img
                v-if="userInformations && userInformations.avatar"
                :src="getImage(userInformations.avatar)"
                alt="Avatar"
                class="border-radius-lg"
              />
              <div
                v-else-if="
                  userInformations &&
                  userInformations.firstname &&
                  userInformations.lastname
                "
                class="text-white font-weight-bold"
                style="font-size: 24px"
              >
                {{ userInformations.firstname.charAt(0)
                }}{{ userInformations.lastname.charAt(0) }}
              </div>
              <i
                v-else
                class="material-icons-round text-white"
                style="font-size: 40px"
                >person</i
              >
            </v-avatar>
          </v-col>
          <v-col cols="auto" class="my-auto">
            <div class="h-100 pa-3">
              <h5 class="mb-1 text-h5 text-typo font-weight-bold">
                {{ userInformations && userInformations.firstname ? userInformations.firstname : '' }}
                {{ userInformations && userInformations.lastname ? userInformations.lastname : '' }}
              </h5>
              <p class="mb-0 font-weight-light text-body text-sm">
                {{ userInformations && userInformations.companyName ? userInformations.companyName : '' }}
              </p>
            </div>
          </v-col>
        </v-row>

        <!-- Back Button & Header -->
        <v-row :class="$vuetify.breakpoint.xs ? 'mt-4 mb-2' : 'mt-8 mb-4'" v-if="computedTickets[0]">
          <v-col cols="12" class="d-flex align-center mb-3">
            <v-btn
              icon
              @click="$router.push('/tickets')"
              class="mr-3"
              :small="$vuetify.breakpoint.xs"
              :large="!$vuetify.breakpoint.xs"
            >
              <i class="material-icons-round">chevron_left</i>
            </v-btn>
            <div class="flex-grow-1">
              <h3 :class="$vuetify.breakpoint.xs ? 'text-h5' : 'text-h3'" class="text-typo font-weight-bolder mb-1">
                {{ computedTickets[0].event.title }}
              </h3>
              <p :class="$vuetify.breakpoint.xs ? 'text-caption' : 'text-body'" class="font-weight-light mb-0" style="color: #718096">
                {{ computedTickets[0].event.date | moment("DD.MM.YYYY HH:mm") }} Uhr • {{ computedTickets[0].participants.length }} {{ computedTickets[0].participants.length === 1 ? 'Ticket' : 'Tickets' }}
              </p>
            </div>
          </v-col>
        </v-row>

        <!-- Back Button (Loading/Empty State) -->
        <v-row v-if="loadingEventEntries || !computedTickets || computedTickets.length === 0 || !computedTickets[0] || computedTickets[0].participants.length === 0" :class="$vuetify.breakpoint.xs ? 'mt-4 mb-2' : 'mt-8 mb-4'">
          <v-col cols="12">
            <v-btn
              icon
              @click="$router.push('/tickets')"
              :small="$vuetify.breakpoint.xs"
              :large="!$vuetify.breakpoint.xs"
            >
              <i class="material-icons-round">chevron_left</i>
            </v-btn>
          </v-col>
        </v-row>

        <!-- Loading State -->
        <v-row v-if="loadingEventEntries" :class="$vuetify.breakpoint.xs ? 'mt-4' : 'mt-10'">
          <v-col cols="12">
            <v-card class="card-shadow border-radius-xl py-16 text-center" style="background-color: #f7fafc;">
              <div class="mx-auto mb-6">
                <v-progress-circular
                  :size="50"
                  :width="4"
                  color="warning"
                  indeterminate
                ></v-progress-circular>
              </div>
              <h4 class="text-h4 text-typo font-weight-bolder mb-4">
                Tickets werden geladen...
              </h4>
              <p
                class="text-body font-weight-light px-6"
                style="max-width: 600px; margin: 0 auto; color: #718096"
              >
                Bitte einen Moment Geduld
              </p>
            </v-card>
          </v-col>
        </v-row>

        <!-- Empty State -->
        <v-row v-else-if="!computedTickets || computedTickets.length === 0 || !computedTickets[0] || computedTickets[0].participants.length === 0" :class="$vuetify.breakpoint.xs ? 'mt-4' : 'mt-10'">
          <v-col cols="12">
            <v-card class="card-shadow border-radius-xl py-16 text-center" style="background-color: #f7fafc;">
              <div class="mx-auto mb-6">
                <v-avatar
                  color="bg-gradient-warning"
                  size="100"
                  class="shadow"
                >
                  <i class="material-icons-round text-white" style="font-size: 50px;">confirmation_number</i>
                </v-avatar>
              </div>
              <h4 class="text-h4 text-typo font-weight-bolder mb-4">
                Keine Tickets gefunden
              </h4>
              <p
                class="text-body font-weight-light mb-6 px-6"
                style="max-width: 600px; margin: 0 auto; color: #718096"
              >
                Für dieses Event wurden keine Tickets gefunden.
              </p>
              <v-btn
                :elevation="0"
                class="font-weight-bold text-xs btn-default bg-gradient-warning py-5 px-8"
                color="primary"
                to="/tickets"
              >
                Zurück zu deinen Tickets
              </v-btn>
            </v-card>
          </v-col>
        </v-row>

        <!-- Tickets Grid -->
        <v-row v-else>
          <v-col cols="12" class="position-relative">
            <v-row justify="start">
              <v-col
                v-for="item in computedTickets[0].participants"
                :key="item._id"
                lg="4"
                md="4"
                sm="12"
                cols="12"
                class="pt-0 mb-0"
              >
                <ticket-card-q-r :item="item"></ticket-card-q-r>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
</template>
<script>
import TicketCardQR from "@/components/Widgets/TicketCardQR.vue";
import moment from "moment";
export default {
  name: "TicketDetails",
  components: {
    TicketCardQR,
  },
  data: function () {
    return {};
  },
  computed: {
    userInformations() {
      return this.$store.getters.userInformations;
    },
    eventEntries() {
      return this.$store.getters.eventEntries;
    },
    loadingEventEntries() {
      return this.$store.getters.loadingEventEntries;
    },
    computedTickets() {
      var array = [];
      if (this.eventEntries) {
        this.eventEntries
          .filter((entry) => entry.event._id == this.$route.params.id)
          .forEach((element) => {
            var entryCheck = array.find(
              (entry) => entry.event._id == element.event._id
            );
            if (entryCheck) {
              entryCheck.participants.push({
                _id: element._id,
                participant_data: element.participant_data,
                event: element.event,
                status: element.redeemed,
              });
            } else {
              var newEntry = JSON.parse(JSON.stringify(element));
              newEntry.participants = [];
              newEntry.participants.push({
                _id: element._id,
                participant_data: element.participant_data,
                event: element.event,
                status: element.redeemed,
              });
              array.push(newEntry);
            }
          });
      }
      return array;
    },
  },
  mounted() {
    this.$store.dispatch("tryAutoLogin");
    if (this.$route.query.user) {
      this.$store.dispatch("getEventEntriesUser", {
        user: this.$route.query.user,
        event: this.$route.params.id,
      });
    } else {
      this.$store.dispatch("getEventEntriesUser");
    }
  },
  methods: {
    updateUserData() {
      this.$store.dispatch("updateUserInformations", this.userInformations);
      this.SnackbarShow(
        "Success",
        "Aktion erfolgreich!",
        "Profil gespeichert!"
      );
    },
    getImage(link) {
      return process.env.VUE_APP_API_BASEURL + "/" + link;
    },
  },
};
</script>
